import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../../StyleSheets/Main.css'
import logo from '../../Resources/logo.png'
import { useNavigate } from 'react-router-dom'

const Navbar = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const navigate = useNavigate();
  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  const scrollToProjects = () => {
    const aboutSection = document.getElementById('projects');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  const scrollToContact = () => {
    const aboutSection = document.getElementById('otw');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  const nav = (locations) => {
    navigate(locations);
  }
  const handleNavbarToggle = () => {
    setIsNavbarOpen(!isNavbarOpen);  // Toggle navbar state
  };
  return (
    <nav
      className={`navbar_container navbar navbar-expand-lg navbar-light fixed-top ${isNavbarOpen ? 'navbar-open' : ''}`}
    >
      <div className="container-fluid">
        <a className="navbar-brand navbar_brand_container" href="#">
          <img src={logo} className='navbar_logo_image' alt='Sadhguna Aithal' />
          <span className='navbar_brand_name'>Sadhguna Aithal</span>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded={isNavbarOpen ? 'true' : 'false'}
          aria-label="Toggle navigation"
          onClick={handleNavbarToggle}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto navbar_links_container">
            <li className="nav-item">
              <a
                className="nav-link navbar_link_component"
                href="#about"
                onClick={(e) => {
                  scrollToAbout();
                  document.querySelector('.navbar-collapse').classList.remove('show');
                }}
              >
                About Me
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link navbar_link_component"
                href="#music"
                // onClick={() => {
                //   document.querySelector('.navbar-collapse').classList.remove('show');
                // }}
              >
                Music
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link navbar_link_component"
                href="#projects"
                onClick={(e) => {
                  scrollToProjects();
                  document.querySelector('.navbar-collapse').classList.remove('show');
                }}
              >
                Projects
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link navbar_link_component"
                href="#contact"
                onClick={(e) => {
                  scrollToContact();
                  document.querySelector('.navbar-collapse').classList.remove('show');
                }}
              >
                Contact Me
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar